import React from "react";

export const SlideTaller = props => {
    const {background, title, callback} = props;

    return (
        <div className="tallSlide" onClick={callback}>
            <div className="dark-overlay_simplevideo text-center" />
            <div
                className="overflow-hidden position-absolute w-100 h-100 bg_image_cover w-100"
                style={{
                    backgroundImage: background ? `url(${background})` : null,
                }}
            />
            <div className="d-flex w-100 h-100 py-6 px-5 text-white z-index-2">
                <div className="overflow-hidden d-flex align-items-center justify-content-center h-100 w-100">
                    <div className="title elipsis_3lines">{title}</div>
                </div>
            </div>
        </div>
    );
};
export default SlideTaller;
